import React, { forwardRef,useImperativeHandle,useRef,useEffect } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useGeneralFeatures } from "../../context/GeneralFeaturesContext.jsx";

import { useMasterData } from "../../context/MasterDataContext";



const Comp_GeneralFeatures = forwardRef(({
    maxTags = undefined,
    style = {},       // container style
    tagStyle = {},    // individual tag style
    inputStyle = {},  // input box style

    defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onGeneralFeatureSelect,
    onGeneralFeatureRemove,
    onGeneralFeatureChangeTag,
}, ref) => {
    const placeHolder = "Select Features";
    // const {general:masterGeneral,ready} = useGeneralFeatures(); // Assuming this returns the list of General Features

    // console.log("selectedTags: General Features: ", selectedTags);

    const {generalFeatures:masterGeneral,generalFeaturesReady:ready}= useMasterData();
    


    const tagrefGeneral = useRef(null);
    const hasInitialized = useRef(false);

/**
     * Resolve GeneralTags IDs or mixed tags into full colony objects from masterGeneral.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      // console.log("getObjectFromIds idsOrObjects: ", idsOrObjects);
      
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterGeneral)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'tagname' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterGeneral.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(gen => ({
          ...gen,
          status: defaultStatus
        }));
      }






useEffect(() => {
  if (
    !hasInitialized.current &&
    Array.isArray(defaultTags) &&
    defaultTags.length > 0 &&
    tagrefGeneral.current &&
    ready && // ensure masterColonies are loaded
    Array.isArray(masterGeneral) &&
    masterGeneral.length > 0
  ) {
    // console.log("masterColonies:", masterColonies);
    // console.log("defaultTags:", defaultTags);

    const initialTags = getObjectFromIds(defaultTags)

    tagrefGeneral.current.setTags(initialTags);
    hasInitialized.current = true;
    // console.log("✅ setTags called with:", initialTags);
  }
}, [defaultTags?.length, ready, masterGeneral]);
















        // useEffect(() => {
        //     if (!hasInitialized.current && defaultTags && defaultTags.length > 0 && tagrefGeneral.current) {
        //         tagrefGeneral.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        // }, [defaultTags?.length]);


    //  // Apply defaultTags when they change
    //  useEffect(() => {
    //     if (defaultTags && defaultTags.length > 0) {
    //         tagrefGeneral.current.setTags(defaultTags); // Explicitly set defaultTags
    //         // console.log("Default tags applied:", defaultTags);
    //     }
    // }, [defaultTags]);




    // console.log("Features: " +masterGeneral);

    const handleSelectTag = (tag) => {
        if (onGeneralFeatureSelect) {
            onGeneralFeatureSelect(tag);
        }

    };

    const handleRemoveTag = (tag) => {
        if (onGeneralFeatureRemove) {
            onFeatureRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onGeneralFeatureChangeTag) {
            onGeneralFeatureChangeTag(AllTags);
        }
    };

    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getFeatureTags: () => tagrefGeneral.current.getTags(),
        // setFeatureTags: (selected) => tagrefGeneral.current.setTags(selected)

        getObjectFromIds,
        getFeatureTags: () => selectedTags,
        setFeatureTags: (tags) => setSelectedTags(tags),    

    }));
    



    return (
        <div style={{ width: '100%', height: 'auto',minWidth :"100%"}}>
            <ComponentTagSelector
                ref={tagrefGeneral}
                // style={style}
                style={style}        // container style     
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field
    
                suggestions={masterGeneral}
                defaultTags={defaultTags}
                maxTags={maxTags}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}

                // if nothing is specified then unlimited, else 1 even if 10 is defined
                displayKey="tagname"
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag} // Pass the function correctly
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
        </div>
    );
});

export default Comp_GeneralFeatures;
